import React from 'react';

import { aiMimeTypes } from '@aline/common';

import { getPinnedSkillCardToolCallId } from './pinned-skill-card-id';
import { getSkillLoads } from './skill-load-version-ids';
import type { ChatAssistantMessage } from '../chat-types';
import { ChatPanelMarkdown } from '../ChatPanelMarkdown/ChatPanelMarkdown';

/**
 * A "Loaded <skill>" card for each skill the turn loaded, pinned or picked by Aline. The
 * mention query decides what each card may show, as it does for other tool calls.
 */
export const PinnedSkillCard = React.memo(function PinnedSkillCard({
  message,
  threadId,
}: {
  message: ChatAssistantMessage;
  threadId: string;
}) {
  const loads = getSkillLoads(message.data.uiParts ?? []);
  if (!loads.length) return null;

  const completionText = loads
    .map(({ skillId, versionId }) => {
      const toolCall = {
        id: getPinnedSkillCardToolCallId({ messageId: message.id, versionId }),
        skillId,
        type: 'loadSkill',
        versionId,
      };
      return `\`\`\`${aiMimeTypes.jsonToolCall}\n${JSON.stringify(toolCall)}\n\`\`\``;
    })
    .join('\n\n');

  return (
    <ChatPanelMarkdown
      completionText={completionText}
      documentInView={null}
      message={message}
      threadId={threadId}
    />
  );
});
